import React, { Component, Fragment } from "react";
import Button from "@mui/material/Button";
import { withStyles } from "@mui/styles";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  checkPrivileges,
  errorHandler,
  getAmUserId,
  getCompanies,
} from "../../../../Helpers";
import { parentUsersLimit } from "../../../../Actions/Users";
import { updateAccount } from "../../../../Actions/Accounts";
import { validEmailPattern } from "../../../../Helpers";
import { parentUnitsLimit } from "../../../../Actions/Devices";
import AddUserModal from "../../addAccount";
import MarkerMap from "../../../common/Maps";
import CustomDialog from "../../../common/Dialog";
import { checkUnitsWithStandardType } from "../../../Users/userDataTypes";
import { ServerInfo } from "../../../../Actions/serverSetting";
import instance from "../../../../axios";
import isEqual from "react-fast-compare";

const userDataFormat = (data, extAttriubtes, itemId) => {
  let formattedData = {
    city: data.city ? data.city : "",
    administrator: data.userType === 1 ? false : true,
    attributes: extAttriubtes ? extAttriubtes : {},
    coordinateFormat: data.coordinateFormat ? data.coordinateFormat : "",
    deviceLimit: data.deviceLimit ? data.deviceLimit : "",
    deviceReadonly:
      data.deviceReadonly === "on" || data.deviceReadonly === true
        ? true
        : false,
    disabled: data.disabled === "on" || data.disabled === true ? true : false,
    email: ("" + data.email).trim(),
    expirationTime: data.expirationTime ? data.expirationTime : null,
    id: itemId ? itemId : 0,
    latitude: data.latitude ? data.latitude : 0,
    limitCommands:
      data.limitCommands === "on" || data.limitCommands === true ? true : false,
    login: data.login,
    longitude: data.longitude ? data.longitude : 0,
    map: data.map,
    name: ("" + data.name).trim(),
    phone: data.phone,
    poiLayer: data.poiLayer,
    readonly: data.readonly === "on" || data.readonly === true ? true : false,
    token: data.token,
    twelveHourFormat:
      data.twelveHourFormat === "on" || data.twelveHourFormat === true
        ? true
        : false,
    userLimit: data.userLimit ? data.userLimit : "",
    vehicleLimit: data.vehicleLimit ? data.vehicleLimit : "",
    //creditLimit: data.creditLimit ? data.creditLimit : '',
    zoom: data.zoom ? data.zoom : 0,
    roleId: data.roleId || 0,
    userType: parseInt(data.userType),
    parentId: data.parentId || 0,
    active: data.active || true,
  };
  if (data.customerType) {
    formattedData.customerType = parseInt(data.customerType);
  }
  return formattedData;
};

const accountDataFormat = (data, form, attributes) => {
  let newAttributes = {
    c_buildingNoArabic: "",
    c_addressArabic: "",
    c_streetNameArabic: "",
    c_cityArabic: "",
    c_taxNumber: "",
    ...attributes,
  };
  if (form?.userType === 3) {
    newAttributes.accountControl = Boolean(attributes?.accountControl);
  }
  if (form.status === "credit") {
    newAttributes.c_agreedAdvancePayment = 0;
  }
  if (!newAttributes.c_agreedAdvancePayment) {
    newAttributes.c_agreedAdvancePayment = 0;
  }
  delete newAttributes.c_am;
  const amUserId = getAmUserId({ form, account: data });
  return {
    attributes: newAttributes ? newAttributes : {},
    amUserId,
    // contact: form.accountContact ? form.accountContact : data.contact ? data.contact : "",
    contact: form.accountContact
      ? Array.isArray(form.accountContact)
        ? form.accountContact.length > 0
          ? String(form.accountContact)
          : ""
        : String(form.accountContact)
      : data.contact
        ? Array.isArray(data.contact)
          ? data.contact.length > 0
            ? String(data.contact)
            : ""
          : String(data.contact)
        : "",

    contractType: form?.contractType || 1,
    created: data.created || form.created,
    contractName: form?.contractName || "",
    contractNumber: form?.contractNumber || "",
    pacContractId: form?.pacContractId || "",
    garageNumber: form?.garage
      ? form?.garage.garageNumber
      : form?.garageNumber
        ? form?.garageNumber
        : "",
    vatPercentage: form?.vatPercentage || 0,
    ...(form?.userType === 3 ? { markup: form?.markup || 0 } : {}),
    status: form?.status || 0,
    contractStartDate: form?.contractStartDate || "",
    settleDate: form?.settleDate || "",
    defaultSatisfactionDate: form?.defaultSatisfactionDate || "",
    contractEndDate: form?.contractEndDate || "",
    customerNumber: form?.customerNumber || "",
    // customerType:form?.customerType || "",
    creditLimit: form.status === "advance" ? 0 : form?.creditLimit || 0,
    creditPeriod: form?.creditPeriod || "",
    // buildingNoArabic: form?.buildingNoArabic || '',
    description: form.accountDescription || data.description,
    email: form.accountEmail,
    id: data.id || 0,
    modified: data.modified || form.modified,
    name: form.accountName,
    active: form.active ? true : false,
    nameArabic: form?.nameArabic || "",
    yearlyRevenueTarget: form?.yearlyRevenueTarget || "",
    monthlyRevenueTarget:
      form?.monthlyRevenueTarget || data?.monthlyRevenueTarget || "",
    monthlyRevenueTargets:
      form?.monthlyRevenueTargets || data?.monthlyRevenueTargets || {},
    parentId: data.parentId || 0,
    settingId: data?.settingId || "",
    activeDate: data?.activeDate || "",
    inactiveDate: data?.inactiveDate || "",
    ...(data?.companyId ? { companyId: data.companyId } : {}),
  };
};
let uploadFilesArray = [];
const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
});

class updateAccountDetail extends Component {
  constructor(props) {
    super(props);
    this.initialAmUserId = getAmUserId({ account: props.selectedAccount });
    this.amUserIdTouched = false;
    this.state = {
      value: 0,
      units: "",
      form: {
        ...this.props.selectedUser,
        accountName:
          this.props.selectedAccount?.name ||
          this.props.selectedUser?.extraInfo?.accountName,
        accountEmail:
          this.props.selectedAccount?.email ||
          this.props.selectedUser?.extraInfo?.extraInfo?.accountEmail,
        accountDescription: this.props.selectedAccount?.description || "",
        accountContact: this.props.selectedAccount?.contact || "",
        contractName: this.props.selectedAccount?.contractName || "",
        customerNumber: this.props.selectedAccount?.customerNumber || "",
        contractNumber: this.props.selectedAccount?.contractNumber || "",
        garageNumber: this.props.selectedAccount?.garageNumber || "",
        pacContractId: this.props.selectedAccount?.pacContractId || "",
        vatPercentage: this.props.selectedAccount?.vatPercentage || 0,
        markup: this.props.selectedAccount?.markup || 0,
        status: this.props.selectedAccount?.status || 0,
        contractEndDate: this.props.selectedAccount?.contractEndDate || "",
        contractStartDate: this.props.selectedAccount?.contractStartDate || "",
        settleDate: this.props.selectedAccount?.settleDate || "",
        defaultSatisfactionDate:
          this.props.selectedAccount?.defaultSatisfactionDate || "",
        creditLimit: this.props.selectedAccount?.creditLimit || "",
        creditPeriod: this.props.selectedAccount?.creditPeriod || "",
        contractType: this.props.selectedAccount?.contractType || "",
        nameArabic: this.props.selectedAccount?.nameArabic || "",
        yearlyRevenueTarget:
          this.props.selectedAccount?.yearlyRevenueTarget || "",
        monthlyRevenueTarget:
          this.props.selectedAccount?.monthlyRevenueTarget || "",
        // userType:this.props.selectedAccount?.attributes?.userType || "",
        userType: this.props.selectedAccount?.userType || "",
        active: this.props.selectedAccount?.active ? true : false,
        created: this.props.selectedAccount?.created,
        modified: this.props.selectedAccount?.modified,
        customerType: this.props.selectedAccount?.customerType || "",
        amUserId:
          this.props.selectedAccount?.amUserId ??
          this.props.selectedUser?.amUserId ??
          null,
        ...(this.props.selectedAccount?.companyId
          ? { companyId: this.props.selectedAccount.companyId }
          : {}),
      },

      accountsform: this.props.selectedAccount?.attributes || {},
      newField: "",
      selectedUser: this.props.selectedUser,
      isVisableUserBtn: true,
      duplicateEntry: false,
      userLimit: true,
      vehicleLimit: true,
      deviceLimitError: false,
      userLimitError: false,
      vehicleLimitError: false,
      unitsLimitsMeaasge: "",
      vehicleLimitsMeaasge: "",
      usersLimitsMeaasge: "",
      vehicleLimitsMeaasge: "",
      currentUserRole: [],
      localPostionObj: "",
      isVisableAddlocBtn: false,
      editOption: true,
      notVisableBackbtn: true,
      uploadDoc: [],
      filesData: [],
      emailInvalidError: "",
      accountEmailInvalidError: "",
      markupError: "",
      companySelectedData: "",
      addUserFieldErrors: {},
    };
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.uu_submit = this.uu_submit.bind(this);
    this.generateToken = this.generateToken.bind(this);
    this.timeDateOnchange = this.timeDateOnchange.bind(this);
    this.changeAttribute2 = this.changeAttribute2.bind(this);
  }
  componentWillMount() {
    const c_schemeIdList = [
      { key: 1, name: "TIN" },
      { key: 2, name: "CRN" },
      { key: 3, name: "MOM" },
      { key: 4, name: "MLS" },
      { key: 5, name: "700" },
      { key: 6, name: "SAG" },
      { key: 7, name: "NAT" },
      { key: 8, name: "GCC" },
      { key: 9, name: "IQA" },
      { key: 10, name: "OTH" },
    ];
    if (this.props.selectedAccount.contractType) {
      this.fetchAccountManagersList();
    }
    this.fetchCompaniesList();
    if (this.props.selectedAccount?.attributes?.c_schemeId) {
      const selectedScheme = c_schemeIdList.find(
        (scheme) =>
          scheme.name === this.props.selectedAccount?.attributes.c_schemeId,
      );
      if (selectedScheme) {
        // Dynamically set the value of the second field based on the selected scheme ID
        const newFieldName = `c_schemeNumber`;

        this.setState({
          newField: this.props.selectedAccount?.attributes[newFieldName] || "",
          accountsform: {
            ...this.state.accountsform,
            // [name]: value,
            [newFieldName]:
              this.props.selectedAccount?.attributes[newFieldName] || "",
            // Initialize the value of the new field
          },
        });
      }
    }

    this.setState({
      uploadDoc: [],
      filesData: [],
    });
    uploadFilesArray = [];
  }

  computeEditAccountFieldErrors() {
    const errors = {};
    const { form, accountsform } = this.state;
    const userType = form.userType;
    const accountEmailTrim = String(form.accountEmail ?? "").trim();
    const accountNameTrim = String(form.accountName ?? "").trim();
    // const postalTrim = String(accountsform.c_postalCode ?? "").trim();
    // const isValidAttributes = Boolean(postalTrim);
    if (String(form.name ?? "").trim()) errors.name = true;
    if (String(form.email ?? "").trim()) {
      if (!validEmailPattern.test(form.email)) {
        errors.email = true;
      }
    }
    if (accountEmailTrim && !validEmailPattern.test(form.accountEmail)) {
      errors.accountEmail = true;
    }

    if (userType === 4) {
      if (!accountEmailTrim) errors.accountEmail = true;
      if (!accountNameTrim) errors.accountName = true;
      if (!form.companyId) errors.companyId = true;
    } else if (userType === 3) {
      if (!accountEmailTrim) errors.accountEmail = true;
      if (!String(form.contractName ?? "").trim()) errors.contractName = true;
      if (!form.companyId) errors.companyId = true;
      if (!accountNameTrim) errors.accountName = true;
      if (!form.amUserId && !this.state.managerAccountSelect?.id) {
        errors.amUserId = true;
      }
      // if (!isValidAttributes) errors.c_postalCode = true;
    } else {
      if (!accountEmailTrim) errors.accountEmail = true;
      if (!String(accountsform.c_taxNumber ?? "").trim())
        errors.c_taxNumber = true;
      // if (!postalTrim) errors.c_postalCode = true;
      if (!form.companyId) errors.companyId = true;
      if (!accountNameTrim) errors.accountName = true;
    }

    if (form.vatPercentage !== undefined && form.vatPercentage !== null) {
      const vatNum = Number(form.vatPercentage);
      if (Number.isNaN(vatNum) || vatNum < 0 || vatNum > 100) {
        errors.vatPercentage = true;
      }
    }

    if (userType === 3 && form.markup !== undefined && form.markup !== null) {
      const m = Number(form.markup);
      if (Number.isNaN(m) || m < 0 || m > 100) errors.markup = true;
    }

    if (form.contractStartDate && form.contractEndDate) {
      if (new Date(form.contractStartDate) > new Date(form.contractEndDate)) {
        errors.contractEndDate = true;
      }
    }

    return errors;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedAccount?.id !== this.props.selectedAccount?.id) {
      this.initialAmUserId = getAmUserId({
        account: this.props.selectedAccount,
      });
      this.amUserIdTouched = false;
    } else if (!this.amUserIdTouched && this.initialAmUserId == null) {
      this.initialAmUserId = getAmUserId({
        account: this.props.selectedAccount,
      });
    }
    const current = this.state.addUserFieldErrors;
    if (!current || !Object.keys(current).length) return;
    const nowErrors = this.computeEditAccountFieldErrors();
    const staleKeys = Object.keys(current).filter((k) => !nowErrors[k]);
    if (!staleKeys.length) return;
    const next = { ...current };
    staleKeys.forEach((k) => {
      delete next[k];
    });
    this.setState({
      addUserFieldErrors: Object.keys(next).length ? next : {},
    });
  }

  fetchCompaniesList = async () => {
    try {
      const response = await getCompanies();

      const companies = Array.isArray(response) ? response : response || [];

      const updatedCompanies = companies.map((item) => ({
        ...item,
        label: item.companyName,
      }));
      const company = updatedCompanies?.find(
        (item) => item.id === this.props.selectedAccount.companyId,
      );
      this.setState({
        defaultCompaniesList: updatedCompanies,
        companySelectedData: company,
      });
    } catch (error) {
      console.error("fetchCompaniesList error:", error);
    }
  };
  fetchAccountManagersList = () => {
    const fetchApi = `/api/users/getAllUsersInSystem?search=&userTypes=4`;
    fetch(fetchApi, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((res) => {
            if (res.status === "success") {
              const list = Array.isArray(res?.data?.data)
                ? res.data.data
                : Array.isArray(res?.data)
                  ? res.data
                  : [];
              let result = list.map((item) => {
                const entity = item?.entity || item;
                return {
                  id: entity.id,
                  label: entity.label || entity.name,
                  name: entity.label || entity.name,
                  value: entity.id,
                };
              });
              const cAmId = getAmUserId({
                account: this.props.selectedAccount,
                user: this.props.selectedUser,
                form: this.state.form,
                managerAccountSelect: this.state.managerAccountSelect,
              });
              let selectedAccount = result?.find(
                (item) => String(item?.id) === String(cAmId),
              );
              if (cAmId && !selectedAccount) {
                const fallback = {
                  id: cAmId,
                  value: cAmId,
                  label:
                    this.state.managerAccountSelect?.name ||
                    this.state.managerAccountSelect?.label ||
                    String(cAmId),
                  name:
                    this.state.managerAccountSelect?.name ||
                    this.state.managerAccountSelect?.label ||
                    String(cAmId),
                };
                result = [...(result || []), fallback];
                selectedAccount = fallback;
              }
              this.setState({
                defaultAccountManagerList: result,
                managerAccountSelect: selectedAccount,
              });
            } else if (res?.statusCode === "440") {
              window.location.replace("/login");
            } else if (res.statusCode) {
              var err = res?.message.split(":");
              err[1] = err[1].replace(")", "");
              toast.error(this.props.translate(err[1]));
            }
          });
        }
      })
      .catch((e) => {
        console.log("e =", e);
        //   this.props.dispatch(toast.error({
        //   message: 'somethingWentWrong',
        //   autoDismiss: 5
        // }))
      });
  };
  handleChange2 = (name) => (event) => {
    if (!event) {
      // Handle the case where event is null (e.g., when clearing the input)
      this.setState({
        [name]: null,
      });
      return;
    }
    if (name === "name" || name === "accountName") {
      let value = event.target.value;
      value = value.replace(/[^A-Za-z0-9_ ]/g, "");

      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: value,
          },
        },
        () => this.checkRequiredFields(),
      );

      return;
    }
    if (name === "contractType") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event.target.value,
          },
        },
        () => {
          this.fetchAccountManagersList();
        },
      );
    }
    if (name === "status") {
      this.setState({
        form: {
          ...this.state.form,
          [name]: event.target.value,
          creditLimit: 0,
        },
        accountsform: {
          ...this.state.accountsform,
          c_agreedAdvancePayment: 0.0,
        },
      });
      return;
    }
    const { target } = event;
    if (target && target.type === "checkbox") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: target.checked,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (
      name === "expirationTime" ||
      name === "contractStartDate" ||
      name === "defaultSatisfactionDate" ||
      name === "settleDate" ||
      name === "contractEndDate"
    ) {
      const dateValue = event ? event.toISOString() : null;

      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: dateValue,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else {
      let value = target?.value || "";
      if (value) {
        if (target && target.type === "number") {
          value = parseFloat(value);
        }
        if (name === "deviceLimit") {
          if (parseInt(value) === -1) {
            this.setState(
              {
                deviceLimitError: false,
                unitsLimitsMeaasge: "",
              },
              () => this.checkRequiredFields(),
            );
          } else if (
            parseInt(value) <
            parseInt(
              this.props.selectedUnitsLimits.count +
                this.props.selectedUnitsLimits.reserveLimit,
            )
          ) {
            this.setState(
              {
                deviceLimitError: true,
                unitsLimitsMeaasge: "deviceLimitError",
              },
              () => this.checkRequiredFields(),
            );
          } else if (parseInt(this.props.pUnitLimits.remaningLimit) === -1) {
            this.setState(
              {
                deviceLimitError: false,
                unitsLimitsMeaasge: "",
              },
              () => this.checkRequiredFields(),
            );
          } else if (
            parseInt(value) >
            parseInt(
              this.props.pUnitLimits.limit - this.props.pUnitLimits.totalCount,
            )
          ) {
            this.setState(
              {
                deviceLimitError: true,
                unitsLimitsMeaasge: "deviceLimitErrorParent",
              },
              () => this.checkRequiredFields(),
            );
          } else {
            this.setState(
              {
                deviceLimitError: false,
                unitsLimitsMeaasge: "",
              },
              () => this.checkRequiredFields(),
            );
          }
        }
        if (name === "userLimit") {
          if (
            parseInt(value) === -1 &&
            parseInt(this.props.pUserLimits.remaningLimit) === -1
          ) {
            this.setState(
              {
                userLimitError: false,
                usersLimitsMeaasge: "",
              },
              () => this.checkRequiredFields(),
            );
          } else {
            if (parseInt(value) > -1) {
              if (
                parseInt(value) <
                parseInt(
                  this.props.selectedUserLimits.count +
                    this.props.selectedUserLimits.reserveLimit,
                )
              ) {
                this.setState(
                  {
                    userLimitError: true,
                    usersLimitsMeaasge: "userLimitError",
                  },
                  () => this.checkRequiredFields(),
                );
              } else {
                if (parseInt(this.props.pUserLimits.remaningLimit) === -1) {
                  this.setState(
                    {
                      userLimitError: false,
                      usersLimitsMeaasge: "",
                    },
                    () => this.checkRequiredFields(),
                  );
                } else if (
                  parseInt(value) >
                  parseInt(
                    this.props.pUserLimits.limit -
                      this.props.pUserLimits.totalCount,
                  )
                ) {
                  this.setState(
                    {
                      userLimitError: true,
                      usersLimitsMeaasge: "userLimitErrorParent",
                    },
                    () => this.checkRequiredFields(),
                  );
                } else {
                  this.setState(
                    {
                      userLimitError: false,
                      usersLimitsMeaasge: "",
                    },
                    () => this.checkRequiredFields(),
                  );
                }
              }
            } else {
              if (parseInt(value) <= -1) {
                this.setState(
                  {
                    userLimitError: true,
                    usersLimitsMeaasge: "userLimitErrorParent",
                  },
                  () => this.checkRequiredFields(),
                );
              } else {
                this.setState(
                  {
                    userLimitError: false,
                    usersLimitsMeaasge: "",
                  },
                  () => this.checkRequiredFields(),
                );
              }
            }
          }
        } else if (name === "customerType" || name === "pacContractId") {
          this.setState(
            {
              form: {
                ...this.state.form,
                [name]: value,
              },
            },
            () => this.checkRequiredFields(),
          );
        }
        if (name === "vehicleLimit") {
          if (
            parseInt(value) === -1 &&
            parseInt(this.props.pUserLimits.remaningLimit) === -1
          ) {
            this.setState(
              {
                vehicleLimitError: false,
                vehicleLimitsMeaasge: "",
              },
              () => this.checkRequiredFields(),
            );
          } else {
            if (parseInt(value) > -1) {
              if (
                parseInt(value) <
                parseInt(
                  this.props.selectedUserLimits?.count +
                    this.props.selectedUserLimits?.reserveLimit,
                )
              ) {
                this.setState(
                  {
                    vehicleLimitError: true,
                    vehicleLimitsMeaasge: "userLimitError",
                  },
                  () => this.checkRequiredFields(),
                );
              } else {
                if (parseInt(this.props.pUserLimits?.remaningLimit) === -1) {
                  this.setState(
                    {
                      vehicleLimitError: false,
                      vehicleLimitsMeaasge: "",
                    },
                    () => this.checkRequiredFields(),
                  );
                } else if (
                  parseInt(value) >
                  parseInt(
                    this.props?.pUserLimits?.limit -
                      this.props?.pUserLimits?.totalCount,
                  )
                ) {
                  this.setState(
                    {
                      vehicleLimitError: true,
                      vehicleLimitsMeaasge: "vehicleLimitErrorParent",
                    },
                    () => this.checkRequiredFields(),
                  );
                } else {
                  this.setState(
                    {
                      vehicleLimitError: false,
                      vehicleLimitsMeaasge: "",
                    },
                    () => this.checkRequiredFields(),
                  );
                }
              }
            } else {
              if (parseInt(value) <= -1) {
                this.setState(
                  {
                    vehicleLimitError: true,
                    vehicleLimitsMeaasge: "userLimitErrorParent",
                  },
                  () => this.checkRequiredFields(),
                );
              } else {
                this.setState(
                  {
                    vehicleLimitError: false,
                    vehicleLimitsMeaasge: "",
                  },
                  () => this.checkRequiredFields(),
                );
              }
            }
          }
        }
        this.setState(
          {
            form: {
              ...this.state.form,
              [name]: value,
            },
          },
          () => this.checkRequiredFields(),
        );
      } else if (name === "accountEmail") {
        this.setState(
          {
            form: {
              ...this.state.form,
              [name]: value,
            },
          },
          () => this.checkRequiredFields(),
        );
      } else if (this.state.form[name]) {
        if (target && target.type === "number") {
          value = parseFloat(value);
        }
        if (name === "deviceLimit") {
          if (this.props.pUnitLimits.count !== 0) {
            this.setState(
              {
                deviceLimitError: true,
                unitsLimitsMeaasge: "deviceLimitError",
              },
              () => this.checkRequiredFields(),
            );
          } else {
            this.setState(
              {
                deviceLimitError: false,
              },
              () => this.checkRequiredFields(),
            );
          }
        }
        if (name === "userLimit") {
          if (this.props.selectedUserLimits.count !== 0) {
            this.setState(
              {
                userLimitError: true,
                usersLimitsMeaasge: "userLimitError",
              },
              () => this.checkRequiredFields(),
            );
          } else {
            this.setState(
              {
                userLimitError: false,
              },
              () => this.checkRequiredFields(),
            );
          }
        }
        if (name === "vehicleLimit") {
          if (this.props.selectedUserLimits.count !== 0) {
            this.setState(
              {
                vehicleLimitError: true,
                vehicleLimitsMeaasge: "userLimitError",
              },
              () => this.checkRequiredFields(),
            );
          } else {
            this.setState(
              {
                vehicleLimitError: false,
              },
              () => this.checkRequiredFields(),
            );
          }
        }
        this.setState(
          {
            form: {
              ...this.state.form,
              [name]: value,
            },
          },
          () => this.checkRequiredFields(),
        );
      }
    }
  };

  handleChangeAttributes = (name) => (event) => {
    const c_schemeIdList = [
      { key: 1, name: "TIN" },
      { key: 2, name: "CRN" },
      { key: 3, name: "MOM" },
      { key: 4, name: "MLS" },
      { key: 5, name: "700" },
      { key: 6, name: "SAG" },
      { key: 7, name: "NAT" },
      { key: 8, name: "GCC" },
      { key: 9, name: "IQA" },
      { key: 10, name: "OTH" },
    ];

    let value;
    if (event.target.type === "checkbox") {
      value = event.target.checked; // âœ… true/false
    } else if (name === "c_agreedAdvancePayment") {
      value = parseFloat(event.target.value);
    } else {
      value = event.target.value;
    }

    if (name === "c_schemeId") {
      const selectedScheme = c_schemeIdList.find(
        (scheme) => scheme.name === value,
      );
      if (selectedScheme) {
        const newFieldName = `c_schemeNumber`;
        this.setState({
          accountsform: {
            ...this.state.accountsform,
            [name]: value,
            [newFieldName]: "", // Initialize the value of the new field
          },
        });
      }
    } else if (name === "number") {
      this.setState({
        newField: value,
        accountsform: {
          ...this.state.accountsform,
          ["c_schemeNumber"]: value,
        },
      });
    } else {
      // For other fields (text, number, checkbox, etc.)
      this.setState(
        {
          accountsform: {
            ...this.state.accountsform,
            [name]: value,
          },
        },
        () => {
          this.checkRequiredFields();
        },
      );
    }
  };

  filesDataPrepare = async () => {
    const fieldErrors = this.computeEditAccountFieldErrors();
    if (Object.keys(fieldErrors).length > 0) {
      this.setState({ addUserFieldErrors: fieldErrors });
      toast.error(this.props.translate("emptyField"));
      return;
    }
    this.setState({ addUserFieldErrors: {} });

    let { filesData } = this.state;

    if (filesData && filesData.length > 0) {
      for (let i = 0; i < filesData.length; i++) {
        await instance({
          url: `/api/uploads`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            ...filesData[i],
          },
        })
          .then((res) => {})
          .catch((error) => {
            errorHandler(error, this.props.dispatch);
          });
      }
      this.uu_submit();
    } else {
      this.uu_submit();
    }
  };
  removeFiles = (key) => {
    let updatedFilesData = [...this.state.filesData];
    updatedFilesData.splice(key, 1);
    uploadFilesArray.splice(key, 1);
    this.setState(
      {
        filesData: updatedFilesData,
        uploadDoc: uploadFilesArray,
      },
      () => this.checkRequiredFields(),
    );
  };

  uploadFiles = (e) => {
    const files = e.target.files;
    let prevSavedImages = this.props.accountFilesData
      ? this.props.accountFilesData
      : [];
    let prevUploadedImages = this.state.uploadDoc ? this.state.uploadDoc : [];

    if (
      prevSavedImages.length + prevUploadedImages.length + files.length <=
      5
    ) {
      Object.values(files).forEach((item) => {
        if (item.size <= 5 * 1024 * 1024) {
          let reader = new FileReader();

          reader.onload = (e) => {
            let fileData = e.target.result;

            if (
              fileData.split(":")[1].split("/")[0] === "image" ||
              fileData
                .split(":")[1]
                .split("/")[1]
                .toLowerCase()
                .substring(0, 3) === "pdf" ||
              fileData
                .split(":")[1]
                .split("/")[1]
                .toLowerCase()
                .substring(0, 3) === "vnd"
            ) {
              uploadFilesArray.push(item.name);
              let obj = {
                name: `${item.name}`,
                contentType: `${item.type}`,
                oldUrl: fileData,
                entity: "Account",
                entityId: this.props.selectedAccount.id,
                data: `${fileData.split("base64")[1].substring(1)}`,
              };

              this.setState(
                (prevState) => ({
                  filesData: [...prevState.filesData, obj],
                  uploadDoc: [...uploadFilesArray],
                }),
                () => this.checkRequiredFields(),
              );
            } else {
              toast.error(this.props.translate("onlyAcceptImagesDocs"));
            }
          };

          reader.readAsDataURL(item);
        } else {
          toast.error(this.props.translate("fileSize5MB"));
        }
      });
    } else {
      toast.error(this.props.translate("fileLimit"));
    }
  };
  checkRequiredFields() {
    let {
      name,
      email,
      roleId,
      userType,
      zoom,
      accountEmail,
      accountName,
      contractStartDate,
      contractEndDate,
      vatPercentage,
      markup,
      contractName,
      companyId,
    } = this.state.form;
    let {
      c_taxNumber,
      c_streetName,
      c_schemeId,
      c_buildingNo,
      c_city,
      c_postalCode,
      c_country,
      c_district,
      c_address,
      c_addressArabic,
      c_streetNameArabic,
      c_districtArabic,
      c_cityArabic,
    } = this.state.accountsform;
    const isValidAttributes =
      // c_taxNumber&&
      true;
    // c_postalCode
    // && c_address &&
    //  c_addressArabic &&
    //   c_streetName &&
    //    c_streetNameArabic &&
    //    c_district &&
    //     c_districtArabic &&
    //      c_city &&
    //      c_cityArabic

    let isValid = true;

    if (email && !validEmailPattern.test(email)) {
      this.setState({
        emailInvalidError: "Please enter a valid email address.",
      });
      isValid = false;
    } else {
      this.setState({ emailInvalidError: "" });
    }

    if (accountEmail && !validEmailPattern.test(accountEmail)) {
      this.setState({
        accountEmailInvalidError: "Please enter a valid email address.",
      });
      isValid = false;
    } else {
      this.setState({ accountEmailInvalidError: "" });
    }

    if (userType === 4) {
      if (!(accountEmail && accountName && companyId)) {
        isValid = false;
      }
    } else if (userType === 3) {
      if (
        !(
          accountEmail &&
          isValidAttributes &&
          contractName &&
          companyId &&
          accountName &&
          (this.state.form.amUserId || this.state.managerAccountSelect?.id)
        )
      ) {
        isValid = false;
      }
    } else {
      if (
        !(
          accountEmail &&
          c_taxNumber &&
          // c_streetName &&
          // c_buildingNo &&
          // c_city &&
          // c_postalCode &&
          // c_country &&
          companyId &&
          // c_district &&
          accountName
        )
      ) {
        isValid = false;
      }
    }
    if (vatPercentage !== undefined && vatPercentage !== null) {
      if (vatPercentage < 0 || vatPercentage > 100) {
        this.setState({ vatPercentageError: "Enter Value between 0 and 100" });
        isValid = false;
      } else {
        this.setState({ vatPercentageError: "" });
      }
    }
    if (userType === 3 && markup !== undefined && markup !== null) {
      if (markup < 0 || markup > 100) {
        this.setState({ markupError: "Enter Value between 0 and 100" });
        isValid = false;
      } else {
        this.setState({ markupError: "" });
      }
    } else {
      this.setState({ markupError: "" });
    }

    if (contractStartDate && contractEndDate) {
      const startDate = new Date(contractStartDate);
      const endDate = new Date(contractEndDate);
      if (startDate > endDate) {
        this.setState({
          contractEndDateError:
            "Contract end date must be after contract start date",
        });
        isValid = false;
      } else {
        this.setState({ contractEndDateError: "" });
      }
    }

    this.setState({
      isVisableUserBtn: isValid,
      duplicateEntry: false,
    });
  }
  changeAttribute2(name, event) {
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    if (!value) {
      let a = { ...this.state.form.attributes };
      delete a[name];
      if (!Object.keys(a).length) {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes:
                this.props.selectedUser.attributes === null ? null : {},
            },
          },
          () => this.checkRequiredFields(),
        );
      } else {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: {
                ...a,
              },
            },
          },
          () => this.checkRequiredFields(),
        );
      }
    } else {
      if (name === "parking.minIdleTime") {
        value = parseFloat(value);
      }
      if (name === "parking.maxIdleSpeed") {
        value = parseFloat(value);
      }
      if (name === "measurementStandard") {
        let data = checkUnitsWithStandardType(value);
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: {
                ...this.state.form.attributes,
                [name]:
                  event.target.type === "number" ? parseInt(value) : value,
                distanceUnit: data[0].distanceUnit.key,
                speedUnit: data[0].speedUnit.key,
                volumeUnit: data[0].volumeUnit.key,
              },
            },
          },
          () => this.checkRequiredFields(),
        );
      } else {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: {
                ...this.state.form.attributes,
                [name]: value,
              },
            },
          },
          () => this.checkRequiredFields(),
        );
      }
    }
  }

  changeLimit = (name, event) => {
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    // this.setState({
    //   [name]: value,
    // });
    this.setState(
      {
        [name]: value,
        form: {
          ...this.state.form,
          deviceLimit: value ? -1 : 0,
          vehicleLimit: value ? -1 : 0,
          userLimit: value ? -1 : 0,
        },
        ...(value
          ? {
              deviceLimitError: false,
              userLimitError: false,
              vehicleLimitError: false,
              unitsLimitsMeaasge: "",
              usersLimitsMeaasge: "",
              vehicleLimitMeaasge: "",
            }
          : {}),
      },
      () => this.checkRequiredFields(),
    );
  };
  timezone_handleChange = (name, value) => {
    if (name === "c_am" || name === "amUserId") {
      this.amUserIdTouched = true;
      this.setState(
        {
          form: {
            ...this.state.form,
            amUserId: value?.id ?? value?.value ?? null,
          },
          managerAccountSelect: value,
        },
        () => {
          this.checkRequiredFields();
        },
      );
      return;
    } else if (name === "companyId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: value.id,
          },
          companySelectedData: value,
        },
        () => {
          this.checkRequiredFields();
        },
      );
      return;
    }
    if (!value || value.value === "None") {
      if (this.state.form.attributes && this.state.form.attributes[name]) {
        delete this.state.form.attributes[name];
      }
      let a = { ...this.state.form.attributes };
      delete a[name];
      if (!Object.keys(a).length) {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes:
                this.props.selectedUser.attributes === null ? null : {},
            },
          },
          () => this.checkRequiredFields(),
        );
      } else {
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: {
                ...this.state.form.attributes,
              },
            },
          },
          () => this.checkRequiredFields(),
        );
      }
    } else {
      this.setState(
        {
          form: {
            ...this.state.form,
            attributes: {
              ...this.state.form.attributes,
              [name]: value.value,
            },
          },
        },
        () => this.checkRequiredFields(),
      );
    }
  };

  getUsersLimits = () => {
    if (this.props.logInUser.id) {
      //units limits
      if (checkPrivileges("device")) {
        fetch(`/api/devices/count?userId=${this.props.logInUser.id}`)
          .then((response) => {
            if (response.ok) {
              response.json().then((res) => {
                if (res.status === "success") {
                  this.props.dispatch(parentUnitsLimit(res.data));
                } else if (res?.statusCode === "440") {
                  window.location.replace("/login");
                } else if (res.statusCode) {
                  var err = res?.message.split(":");
                  err[1] = err[1].replace(")", "");
                  toast.error(this.props.translate(err[1]));
                }
              });
            } else {
              throw response;
            }
          })
          .catch((e) => {});
      }
      //users limits
      if (checkPrivileges("user")) {
        fetch(`/api/users/count?userId=${this.props.logInUser.id}`)
          .then((response) => {
            if (response.ok) {
              response.json().then((res) => {
                if (res.status === "success") {
                  this.props.dispatch(parentUsersLimit(res.data));
                } else if (res?.statusCode === "440") {
                  window.location.replace("/login");
                } else if (res.statusCode) {
                  var err = res?.message.split(":");
                  err[1] = err[1].replace(")", "");
                  toast.error(this.props.translate(err[1]));
                }
              });
            } else {
              throw response;
            }
          })
          .catch((e) => {});
      }
    }
  };
  generateToken() {
    let symbols =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let i,
      newToken = "";
    for (i = 0; i < 32; i++) {
      newToken += symbols.charAt(Math.floor(Math.random() * symbols.length));
    }
    this.setState(
      {
        form: {
          ...this.state.form,
          token: newToken,
        },
      },
      () => this.checkRequiredFields(),
    );
  }
  timeDateOnchange(date) {
    this.setState((preState) => ({
      ...preState,
      form: {
        ...preState.form,
        timeDate: date,
      },
    }));
  }
  setExpirationTime = (e) => {
    e.stopPropagation();
    if (this.state.form.expirationTime) {
      this.setState(
        {
          form: {
            ...this.state.form,
            expirationTime: null,
          },
        },
        () => this.checkRequiredFields(),
      );
    }
  };
  handleClickShowPostion = () => {
    this.setState({
      isMapModal: true,
      isVisableAddlocBtn: false,
    });
  };
  getPostion = (latlng, zoom) => {
    if (latlng.lat && latlng.lng && zoom) {
      this.setState({
        localPostionObj: { latlng, zoom },
        isVisableAddlocBtn: true,
      });
    }
  };
  setNoToken = (e) => {
    e.stopPropagation();
    this.setState(
      {
        form: {
          ...this.state.form,
          token: null,
        },
      },
      () => this.checkRequiredFields(),
    );
  };
  setSelectedLocation = () => {
    const { localPostionObj } = this.state;
    if (localPostionObj) {
      this.setState(
        {
          form: {
            ...this.state.form,
            latitude: localPostionObj.latlng.lat,
            longitude: localPostionObj.latlng.lng,
            zoom: localPostionObj.zoom,
          },
          isMapModal: false,
        },
        () => this.checkRequiredFields(),
      );
    }
  };
  onCloseModal = () => {
    this.setState({
      isMapModal: false,
    });
  };

  uu_submit() {
    const { selectedUser } = this.state;
    let { name, email, attributes } = this.state.form;
    if (("" + name).trim().length > 0 && ("" + email).trim().length > 0) {
      let itemId = selectedUser.id;
      const obj = userDataFormat(this.state.form, attributes, itemId);
      const AccountObj = accountDataFormat(
        this.props.selectedAccount,
        this.state.form,
        this.state.accountsform,
      );
      const amUserId = getAmUserId({
        managerAccountSelect: this.state.managerAccountSelect,
        form: this.state.form,
        account: this.props.selectedAccount,
        user: this.props.selectedUser,
      });
      AccountObj.amUserId = amUserId;
      fetch(`/api/accounts/${this.props.selectedAccount.id}`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...AccountObj,
        }),
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              let account = res.data;
              if (res.status === "success") {
                this.setState(
                  {
                    isVisableUserBtn: false,
                    addUserFieldErrors: {},
                    uploadDoc: [],
                    filesData: [],
                    form: {
                      ...this.state.form,
                      accountName: AccountObj?.name || "",
                      accountEmail: AccountObj?.email || "",
                      accountDescription: AccountObj?.description || "",
                      accountContact: AccountObj?.contact || "",
                      contractName: AccountObj?.contractName || "",
                      customerNumber: AccountObj?.customerNumber || "",
                      customerType: AccountObj?.customerType || "",
                      contractNumber: AccountObj?.contractNumber || "",
                      garageNumber: AccountObj?.garageNumber || "",
                      pacContractId: AccountObj?.pacContractId || "",
                      vatPercentage: AccountObj?.vatPercentage || 0,
                      markup: AccountObj?.markup || 0,
                      status: AccountObj?.status || 0,
                      contractEndDate: account?.contractEndDate || "",
                      contractStartDate: account?.contractStartDate || "",
                      settleDate: account?.settleDate || "",
                      defaultSatisfactionDate:
                        account?.defaultSatisfactionDate || "",
                      creditLimit: AccountObj?.creditLimit || "",
                      creditPeriod: AccountObj?.creditPeriod || "",
                    },
                  },
                  () => {
                    this.props.updateSelectedAccount(account);
                    this.props.getAccountFilesData(
                      this.props.selectedAccount.id,
                    );
                  },
                );
                const { userType, userId } = res?.data || {};

                const allowedTypes = [-1, 5, 6, 0];
                const nextAmUserId = amUserId;
                const prevAmUserId = this.initialAmUserId;

                if (
                  allowedTypes.includes(userType) &&
                  userId &&
                  nextAmUserId != null &&
                  String(prevAmUserId) !== String(nextAmUserId)
                ) {
                  this.initialAmUserId = nextAmUserId;
                  this.amUserIdTouched = false;
                  // managedUserId permission call disabled
                  // const assignManager = () => {
                  //   return this.unitToUserpermission(nextAmUserId, userId, "POST");
                  // };
                  // if (prevAmUserId != null) {
                  //   this.unitToUserpermission(
                  //     prevAmUserId,
                  //     userId,
                  //     "DELETE",
                  //   ).finally(assignManager);
                  // } else {
                  //   assignManager();
                  // }
                }

                this.props.dispatch(updateAccount(account));
                toast.success(this.props.translate("accountIsUpdated"));
                uploadFilesArray = [];
                this.props.getMoreAccounts();
                // form: { ...this.props.selectedUser, accountEmail:this.props.selectedUser&&this.props.selectedUser.extraInfo&&this.props.selectedUser.extraInfo.accountEmail },
                if (this.props.selectedAccount.id === 1) {
                  this.props.dispatch(ServerInfo(account));
                }
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                var err = res?.message.split(":");
                err[1] = err[1].replace(")", "");
                toast.error(this.props.translate(err[1]));
              }
            });
          }
        })
        .catch((e) => {
          toast.error(this.props.translate("somethingWentWrong"));
        });
    } else {
      this.setState({
        isVisableUserBtn: false,
        addUserFieldErrors: this.computeEditAccountFieldErrors(),
      });
      toast.error(this.props.translate("emptyField"));
    }
  }

  unitToUserpermission(userId, managedUserId, method = "POST") {
    let obj = {
      userId: userId,
      managedUserId: managedUserId,
    };

    return fetch(`/api/permissions`, {
      method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...obj,
      }),
    })
      .then((response) => {
        return response.json().then((res) => {
          if (res.status === "success") {
            toast.success(
              this.props.translate(
                method === "DELETE"
                  ? "userIsUnAssignedSuccessfully"
                  : "userIsAssignedSuccessfully",
              ),
            );
          } else if (res?.statusCode === "440") {
            window.location.replace("/login");
          } else if (res?.statusCode) {
            var err = res.message.split(":");
            var err2 = err[1].split("&#");
            toast.error(this.props.translate(err2[0]));
          } else {
            throw response;
          }
        });
      })
      .catch((e) => {
        if (e && e.text) {
          e.text().then((err) => {
            if (err.includes("You cannot unlink unit")) {
              this.props.dispatch(
                toast.error(this.props.translate("youCannotUnlinkUnit")),
              );
            }
          });
        }
      });
  }
  handleChangeExpense = (name, value) => {
    if (name === "garage") {
      this.setState(
        {
          form: {
            ...this.state.form,
            garage: value,
          },
        },
        () => {
          this.checkRequiredFields();
        },
      );
    }
  };
  render() {
    return (
      <Fragment>
        <AddUserModal
          function={"updateUser"}
          editOption
          {...this.state}
          {...this.props}
          handleChangeExpense={this.handleChangeExpense}
          accountEmailInvalidError={this.state.accountEmailInvalidError}
          changeLimit={this.changeLimit}
          isVisableUserBtn={true}
          addUserFieldErrors={this.state.addUserFieldErrors}
          form={this.state.form}
          defaultCompaniesList={this.state.defaultCompaniesList}
          companySelectedData={this.state.companySelectedData}
          newField={this.state.newField}
          accountsform={this.state.accountsform}
          logInUser={this.props.logInUser}
          padding={"0px"}
          elevation={0}
          formSubmit={this.filesDataPrepare}
          timeDateOnchange={this.timeDateOnchange}
          generateToken={this.generateToken}
          changeAttribute2={this.changeAttribute2}
          handleChange={this.handleChange2}
          buttonText={this.props.translate("update")}
          handleClickShowPostion={this.handleClickShowPostion}
          userType={this.props.logInUser.userType}
          setExpirationTime={this.setExpirationTime}
          setNoToken={this.setNoToken}
          roleTypes={this.props.roles}
          timezone_handleChange={this.timezone_handleChange}
          hasAccessOfUpdate={checkPrivileges("userUpdate")}
          hasAccessOfDelete={checkPrivileges("userDelete")}
          hasAccessOfCreate={checkPrivileges("userCreate")}
          // usersLimit={this.props.pUserLimits.limit-this.props.pUserLimits.totalCount}
          // vehicleLimit={this.props.pUserLimits.limit-this.props.pUserLimits.totalCount}
          // deviceLimit={this.props.pUnitLimits.limit-this.props.pUnitLimits.totalCount}
          // createdUnits={this.props.selectedUnitsLimits.unitCount}
          // createdUsers={this.props.selectedUnitsLimits.totalCount}
          handleChangeAttributes={this.handleChangeAttributes}
          uploadFiles={this.uploadFiles}
          removeFiles={this.removeFiles}
          uploadDoc={this.state.uploadDoc}
          accountFilesData={this.props.accountFilesData}
          removeAccountFile={this.props.removeAccountFile}
        />
        {this.state.isMapModal && (
          <CustomDialog
            title={this.props.translate("setLocation")}
            themeColors={this.props.themeColors}
            visable={true}
            onClose={this.onCloseModal}
            isButtonVisable={true}
            draggable={true}
            fullWidth
            CancelText={this.props.translate("sharedBack")}
            headerActions={
              <Button
                size="small"
                variant="contained"
                color="secondary"
                disabled={!this.state.isVisableAddlocBtn}
                onClick={() => this.setSelectedLocation()}
              >
                {" "}
                {this.props.translate("sharedAdd")}
              </Button>
            }
            bodyPadding={0}
          >
            <MarkerMap
              getPostion={this.getPostion}
              minHeight={500}
              zoom={this.state.selectedUser.zoom || 0}
              lat={this.state.selectedUser.latitude || 0}
              lng={this.state.selectedUser.longitude || 0}
              height={"100%"}
            />
          </CustomDialog>
        )}
      </Fragment>
    );
  }
}

const UpdateAccountDetail = withStyles(styles);
export default UpdateAccountDetail(updateAccountDetail);

// const UpdateUserDetail = withStyles(styles)
// export default UpdateUserDetail((updateUserDetail))
